import { getChartLabel } from "./chartLabel";
import {
  LineChart,
  Line,
  ResponsiveContainer,
  Legend,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { useState } from "react";
import { Form } from "react-bootstrap";
import CustomLegend from "./CustomLegend";
import CustomTooltip from "./CustomTooltip";
//kpi-10
const TB = ({ data, filters, selectedState }) => {
  const [showTable, setShowTable] = useState(false);
  const [sortColumn, setSortColumn] = useState("tb");
  const [sortOrder, setSortOrder] = useState("asc");

  if (!Array.isArray(data) || data.length === 0) {
    return (
      <div
        style={{
          textAlign: "center",
          padding: "40px",
          backgroundColor: "#fff",
          border: "1px solid #ddd",
          borderRadius: "8px",
          marginTop: "20px",
        }}
      >
        <h5 style={{ color: "#666", fontSize: "20px" }}>No data available</h5>
      </div>
    );
  }

  const tbData = data.map((item) => ({
    place: item.Place,
    tb: Number(item.tb_out_referral),
    // percentage_tb: Number(item.percentage_tb_out_referral),
  }));

  const sortedData = [...tbData].sort((a, b) => {
    if (sortColumn === "tb") {
      return sortOrder === "asc" ? a.tb - b.tb : b.tb - a.tb;
    }
    return 0;
  });

  const handleSort = (column) => {
    if (column !== "tb") return;
    if (sortColumn === column) {
      setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortColumn(column);
      setSortOrder("asc");
    }
  };

  // --- Chunking logic ---
  const getChartCount = (length) => {
    if (length < 9) return 1;
    if (length >= 9 && length <= 18) return 2;
    if (length <= 45) return 3;
    return Math.ceil(length / 20);
  };

  const chunkArray = (array, numChunks) => {
    const chunkSize = Math.ceil(array.length / numChunks);
    const chunks = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
  };

  const chartCount = getChartCount(tbData.length);
  const chunkedData = chunkArray(tbData, chartCount);

  return (
    <div style={{ width: "100%", position: "relative" }}>
      {/* Toggle Switch */}
      <div className="card hptCard mt-4 border-0">
        <div className="card-header brBtomlr">
          <div className="headnumText justify-content-between">
            <div className="cardTitle">
              <h5>
                NACP to NTEP Referral {getChartLabel(filters, selectedState)}
              </h5>
            </div>

            <div class="cardDropDown gap-3">
              <div style={{ marginRight: "10px", fontWeight: 500 }}>
                {showTable ? "Chart View" : "Table View"}
              </div>
              <Form>
                <Form.Check
                  type="switch"
                  id="chart-table-toggle"
                  onChange={() => setShowTable((prev) => !prev)}
                  checked={showTable}
                />
              </Form>
            </div>
          </div>
        </div>
      </div>

      {showTable ? (
        // Table View
        <div className="card hptCard mt-4 border-0">
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead className="thead-light">
                <tr>
                  <th className="fw-bold">Place</th>
                  <th
                    className="text-center fw-bold cursor-pointer"
                    onClick={() => handleSort("tb")}
                  >
                    No of TB symptomatic cases referred
                    {sortColumn === "tb"
                      ? sortOrder === "asc"
                        ? "▲"
                        : "▼"
                      : "⬍"}
                  </th>
                </tr>
              </thead>
              <tbody>
                {sortedData.map((item, idx) => (
                  <tr key={idx}>
                    <td style={{ fontWeight: "bold" }}>{item.place}</td>
                    <td>{item.tb}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        // Chart View - Multiple chunks
        chunkedData.map((chunk, idx) => (
          <div className="card hptCard mt-4 border-0" key={idx}>
            <div className="card-body">
              <h6 style={{ fontWeight: "bold" }}> TB Symptomatic Referrals</h6>
            </div>
            <ResponsiveContainer width="100%" height={500}>
              <LineChart
                width={500}
                height={500}
                data={chunk}
                margin={{ top: 10, right: 30, left: 0, bottom: 130 }}
              >
                <XAxis
                  dataKey="place"
                  angle={-90}
                  textAnchor="end"
                  interval={0}
                  label={{
                    value: "",
                    position: "insideBottom",
                    offset: -110,
                    color: "#ca8282ff",
                    fontWeight: "bold",
                  }}
                />
                <YAxis />
                <Tooltip content={<CustomTooltip />} />
                <Legend verticalAlign="top" content={<CustomLegend />} />
                <Line
                  type="monotone"
                  dataKey="tb"
                  stroke="#00a084"
                  fill="#00a084"
                  name="No of TB symptomatic cases referred for confirmation & treatment"
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
        ))
      )}
    </div>
  );
};

export default TB;
